import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useTanquesSection } from "./use-tanques-section";
import { TanquesSectionView } from "./view-tanques-section";

export function TanquesSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useTanquesSection(props);

  return <TanquesSectionView {...vm} />;
}

export type * from "./types-tanques-section";
